<template>
  <div class="relative inline-block w-full text-left">
    <div>
      <div
        v-if="$slots['activator']"
        @click="open = !open">
        <slot name="activator" />
      </div>
      <button
        v-else
        id="options-menu"
        type="button"
        class="focus:outline-none inline-flex w-full items-center justify-between border-0 border-l-0 px-0 py-1 underline focus:ring-0"
        style="width: 200px"
        aria-expanded="true"
        aria-haspopup="true"
        @click="open = !open">
        <div class="flex">
          {{ name }}

          <!-- Heroicon name: solid/chevron-down -->
          <div class="flex items-center">
            <svg
              class="-mr-1 ml-1 h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true">
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
          </div>
        </div>
      </button>
    </div>

    <div
      v-if="open"
      class="fixed left-0 top-0 h-full w-full bg-transparent"
      @click="open = false" />
    <div
      v-if="open"
      class="w-fit focus:outline-none align-tab-item absolute z-20 mt-2 max-h-40 max-w-[200px] origin-top-right overflow-auto rounded-sm bg-white font-normal shadow-lg focus:shadow-none"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu">
      <div
        class="py-1"
        role="none">
        <div
          v-if="showDashboardMap"
          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
          role="menuitem"
          @click="onClick(null)">
          {{ $t("message.nationwide") }}
        </div>
        <template
          v-for="(item, index) in items"
          :key="index">
          <div
            :class="[
              'tab-item',
              selected === item.race_id ? 'font-bold text-black' : 'text-gray-700',
            ]"
            role="menuitem"
            @click="onClick(item)">
            {{ itemText ? itemText(item) : item }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const props = {
  name: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  onSelect: {
    type: Function,
    required: true,
  },
  itemText: {
    type: Function,
    required: false,
  },
  showDashboardMap: {
    type: Boolean,
    required: true,
  },
  selected: {
    type: Number,
    required: false,
  },
};

export default {
  props,
  data: () => ({
    open: false,
  }),
  methods: {
    onClick(item) {
      this.onSelect(item, this.name);
      this.open = false;
    },
  },
};
</script>

<style scoped>
.tab-item {
  @apply block px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900;
}

.align-tab-item {
  right: 0;
}
</style>
